// cspell: disable
/**
 * A mapping of language identifiers to their canonical display names
 */
export const languages: Readonly<Record<string, string>> = {
  "abap": "ABAP",
  "apex": "Apex",
  "azcli": "Azure CLI",
  "bat": "Batch",
  "bicep": "Bicep",
  "cameligo": "CameLIGO",
  "clojure": "Clojure",
  "coffee": "CoffeeScript",
  "cpp": "C++",
  "csharp": "C#",
  "csp": "CSP",
  "css": "CSS",
  "cypher": "Cypher",
  "dart": "Dart",
  "dockerfile": "Dockerfile",
  "ecl": "ECL",
  "elixir": "Elixir",
  "flow9": "Flow9",
  "fsharp": "F#",
  "freemarker2": "FreeMarker2",
  "go": "Go",
  "graphql": "GraphQL",
  "handlebars": "Handlebars",
  "hcl": "HCL",
  "html": "HTML",
  "ini": "INI",
  "java": "Java",
  "javascript": "JavaScript",
  "julia": "Julia",
  "kotlin": "Kotlin",
  "less": "LESS",
  "lexon": "Lexon",
  "lua": "Lua",
  "liquid": "Liquid",
  "m3": "M3",
  "markdown": "Markdown",
  "mdx": "MDX",
  "mips": "MIPS",
  "msdax": "MSDAX",
  "mysql": "MySQL",
  "objective-c": "Objective-C",
  "pascal": "Pascal",
  "pascaligo": "PascaLIGO",
  "perl": "Perl",
  "pgsql": "PostgreSQL",
  "php": "PHP",
  "pla": "PLA",
  "postiats": "PostiATS",
  "powerquery": "Power Query",
  "powershell": "PowerShell",
  "protobuf": "Protocol Buffers",
  "pug": "Pug",
  "python": "Python",
  "qsharp": "Q#",
  "r": "R",
  "razor": "Razor",
  "redis": "Redis",
  "redshift": "Redshift",
  "restructuredtext": "reStructuredText",
  "ruby": "Ruby",
  "rust": "Rust",
  "sb": "SB",
  "scala": "Scala",
  "scheme": "Scheme",
  "scss": "SCSS",
  "shell": "Shell",
  "solidity": "Solidity",
  "sophia": "Sophia",
  "sparql": "SPARQL",
  "sql": "SQL",
  "st": "ST",
  "swift": "Swift",
  "systemverilog": "SystemVerilog",
  "tcl": "Tcl",
  "twig": "Twig",
  "typescript": "TypeScript",
  "typespec": "TypeSpec",
  "vb": "Visual Basic",
  "wgsl": "WGSL",
  "xml": "XML",
  "yaml": "YAML",
}
// cSpell:enable
